export default __webpack_public_path__ + "static/media/blank.8c8b626c.txt";